import { casdoorAuthService } from '@/api/services';
import type { ICasdoorAuthDataResponse } from '@/api/types';
import { ENVS } from '@/shared/consts';

import type { ICasdoorAuthDataRequest, IUpdateAuthDataRequest } from './types';

export const authCasdoorService = casdoorAuthService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить авторизационные данные от Casdoor
     */
    getCasdoorAuthData: builder.mutation<ICasdoorAuthDataResponse, ICasdoorAuthDataRequest>({
      query: ({ authorizationCode, codeVerifier }) => ({
        method: 'POST',
        url: '/login/oauth/access_token',
        body: {
          grant_type: 'authorization_code',
          client_id: ENVS.CASDOOR_CLIENT_ID,
          code: authorizationCode,
          code_verifier: codeVerifier,
        },
      }),
    }),
    /**
     * Получить новую пару токенов по рефреш-токену
     */
    updateAuthData: builder.mutation<ICasdoorAuthDataResponse, IUpdateAuthDataRequest>({
      query: ({ refreshToken }) => ({
        method: 'POST',
        url: '/login/oauth/refresh_token',
        body: {
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
          scope: 'openid+profile+email',
          client_id: ENVS.CASDOOR_CLIENT_ID,
        },
      }),
    }),
  }),
});

export const { useGetCasdoorAuthDataMutation, useUpdateAuthDataMutation } = authCasdoorService;
